// extracted by mini-css-extract-plugin
export default {"container":"expiredPlan_container__xWGx+","title":"expiredPlan_title__Gxwjh","record-label":"expiredPlan_record-label__RLc1Y"};